import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'reset.password.tabs.point.verify.email': {
    id: 'reset.password.tabs.point.verify.email',
    defaultMessage: 'Verify Email',
    description: '',
  },
  'reset.password.tabs.point.change.password': {
    id: 'reset.password.tabs.point.change.password',
    defaultMessage: 'Change Password',
    description: '',
  },
  'verification.code.input.invalid.value': {
    id: 'verification.code.input.invalid.value',
    defaultMessage: 'The code entered is incorrect. You can try entering the code again.',
    description: '',
  },
  'verification.code.input.expired.value': {
    id: 'verification.code.input.expired.value',
    defaultMessage: 'The code entered is expired! You can request an email with a new code.',
    description: '',
  },
  'verification.code.success.text': {
    id: 'verification.code.success.text',
    defaultMessage: 'Code verified!',
    description: '',
  },
  'verification.code.page.title': {
    id: 'verification.code.page.title',
    defaultMessage: 'Verification code',
    description: '',
  },
  'verification.code.page.subtitle': {
    id: 'verification.code.page.subtitle',
    defaultMessage: 'Enter the verification code that was sent to your email',
    description: '',
  },
  'verification.code.page.get.new.code': {
    id: 'verification.code.page.get.new.code',
    defaultMessage: 'Get new verification code',
    description: '',
  },
  'verification.code.page.choose.new.password.button': {
    id: 'verification.code.page.choose.new.password.button',
    defaultMessage: 'Choose my new password',
    description: '',
  },
  'verification.code.page.button': {
    id: 'verification.code.page.button',
    defaultMessage: 'Enter Code',
    description: '',
  },
});

export default messages;
